import React from "react";
import PMGatiShaktiTag from "./../../assets/PM-GATISHAKTI-TAG.svg";

export const PmGatiShakti = ({ className, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={PMGatiShaktiTag} />
    </div>
  ) : null;
};
